import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  item: PropTypes.object
};

/**
 * @component JsonLd
 * 
 * @param {object} props
 * 
 * @prop {*} item
 * 
 * @return {JSX}
 */
const JsonLd = props => {
  const { item } = props;
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}></script>;
};

JsonLd.propTypes = propTypes;

export default JsonLd;
